import PropTypes from 'prop-types'

import ModalMobile from '../../../../ui/components/ModalMobile'
import useTranslations from '../../../../i18n/useTranslations'
import { MOBILE_HOME_TABS } from '../../../../common/constants'
import FiltersModalForm from './FiltersModalForm'

const FiltersModal = props => {
  const { isOpen, onClose, type, ...formProps } = props

  const t = useTranslations()

  return (
    <ModalMobile
      isOpen={isOpen}
      onClose={onClose}
      title={t('home:filters', { type: t(`noun:${type}:lowercase`) })}
      anchor="bottom"
      isFiltersModal
    >
      {/* //NOTE: do not render form until modal is open to avoid errors in form initialization */}
      {isOpen ? <FiltersModalForm {...formProps} type={type} /> : null}
    </ModalMobile>
  )
}

FiltersModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(Object.values(MOBILE_HOME_TABS)),
  initialFilters: PropTypes.object,
  data: PropTypes.object,
  statusOptions: PropTypes.array,
  serviceTypeOptions: PropTypes.array,
  onConfirm: PropTypes.func,
}

export default FiltersModal
